import { CONFIG } from './config'

export const ORTHOGRAPHY = ["A", "Á", "Ⱥ", "B", "C", "Ć", "Ȼ", "D", "E", "H", "I", "Í", "J", "K", "₭", "Ḵ", "Ḱ", "L", "Ƚ", "M", "N", "Ṉ", "O", "P", "Q", "S", "Ś", "T", "Ⱦ", "Ṯ", "Ŧ", "U", "W", "W̱", "X", "X̱", "Y", "Z", "¸"];

if (CONFIG.normalization) {
    ORTHOGRAPHY.forEach((val, i) => ORTHOGRAPHY[i] = val.normalize(CONFIG.normalization))
}
